<template>
  <el-dialog :visible.sync="show" title="结算状态批量维护" width="410px">
    <div class="content">
      <div style="padding-bottom: 12px;">
        <el-button type="text" @click="downloadTemp">下载导入模版</el-button>
      </div>
      <div class="upload-wrap">
        <el-upload
          class="upload-demo"
          drag
          accept=".xls, .xlsx"
          :limit="1"
          :auto-upload="false"
          :file-list="fileList"
          :on-change="handleUploadChange"
          :on-remove="() => fileList = []"
          ref="upload"
          action="#">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">点击或拖拽上传文件</div>
          <div class="el-upload__tip" slot="tip">
            请先下载导入模版，填入数据后，再进行上传 <br />
            数量1，大小2M以内，支持格式xls,xlsx
          </div>
        </el-upload>
      </div>
    </div>

    <!-- 导入结果 -->
    <el-dialog
      :visible.sync="showRstDialog"
      append-to-body
      title="导入结果"
      width="410px">
      <div v-if="importRst" class="rst-content">
        <div>总数：<b>{{ importRst['总数'] }}</b> 条，成功：<b class="success-text">{{ importRst['成功'] }}</b> 条，失败：<b class="fail-text">{{ importRst['失败'] }}</b> 条</div>
        <div v-if="importRst['失败明细'] && importRst['失败明细'].length" style="margin-top: 8px;">
          <div style="color: #999; font-size: 12px;">失败明细：</div>
          <div class="fail-list">
            <div v-for="(item, index) in importRst['失败明细']" :key="index">{{ item }}</div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="showRstDialog = false; $emit('on-success')">关闭</el-button>
      </div>
    </el-dialog>

    <div slot="footer">
      <el-button size="mini" @click="$emit('close')">关闭</el-button>
      <el-button size="mini" :disabled="!fileList.length" @click="submitUpload" type="primary">上传</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'importSettlementStatusDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  data () {
    return {
      fileList: [],
      showRstDialog: false,
      importRst: null
    }
  },
  methods: {
    downloadTemp () {
      window.open(location.origin + '/template/结算状态导入模板.xlsx')
    },
    handleUploadChange (file) {
      this.fileList = [file]
    },
    submitUpload () {
      if (!this.fileList.length) return
      const file = this.fileList[0]
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('上传文件的大小不能超过2MB')
        this.fileList = []
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      const formData = new FormData()
      formData.append('file', file.raw)
      this.$http('post', 'mall/supOrderReport/importChannelSettlementStatus', formData, false, false).then(res => {
        if (res) {
          this.fileList = []
          this.importRst = res
          this.showRstDialog = true
        }
      }).catch(() => {
        this.$message.error('导入失败，请检查文件格式是否正确')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>
.content {
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.upload-wrap {
  padding-top: 16px;
}
.rst-content {
  font-size: 14px;
  line-height: 28px;
  color: #333;
}
.success-text {
  color: #67C23A;
}
.fail-text {
  color: #F56C6C;
}
.fail-list {
  font-size: 12px;
  color: #F56C6C;
  word-break: break-all;
  max-height: 160px;
  overflow-y: auto;
  margin-top: 4px;
  line-height: 20px;
}
</style>
